import { getEnvName } from '../../utils/env';
import './EnvironmentBanner.css';

export const EnvironmentBanner: React.FC = () => {
  // const isProdEnv = isProd();
  const envName = getEnvName().toUpperCase();

  // Don't show banner in production
  // Commenting this out for now. We are showing an empty fixed space right now.
  // if (isProdEnv) {
  //   return null;
  // }

  // Ensure we have an environment name to display
  if (!envName || envName === '') {
    return null;
  }

  // Create array of repeated environment names for seamless scrolling
  const repeatedText = Array.from({ length: 20 }, () => envName);

  return (
    <div
      className="environment-banner h-10 w-full bg-pink-500 font-bold text-text-primary overflow-hidden"
      role="banner"
      aria-label={`Environment: ${envName}`}
    >
      <div className="marquee-container">
        <div className="marquee-content">
          {repeatedText.map((text, index) => (
            <span key={`env-${index}`} className="marquee-item">
              {text}
            </span>
          ))}
        </div>
        {/* Duplicate for seamless loop */}
        <div className="marquee-content" aria-hidden="true">
          {repeatedText.map((text, index) => (
            <span key={`env-duplicate-${index}`} className="marquee-item">
              {text}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};
